import unshowLatestSearchSnackbar
  from '../actions/unshowLatestSearchSnackbar.js'

export default [unshowLatestSearchSnackbar]



// WEBPACK FOOTER //
// ./src/modules/user/chains/unshowLatestSearchSnackbar.js